import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

export const InputField = ({ label, name, register, errors = {}, type = 'text', placeholder = '', controlclass = '', required = false, ...rest }) => {
  const isInvalid = !!errors?.[name];
  return (
    <Form.Group controlId={name} className={controlclass}>
      {label && <Form.Label>{label} {required && <span className="text-danger">*</span>}</Form.Label>}
      <Form.Control
        type={type}
        placeholder={placeholder}
        isInvalid={isInvalid}
        {...(register ? register(name) : {})}
        {...rest}
      />
      <Form.Control.Feedback type="invalid">
        {errors?.[name]?.message}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

InputField.propTypes = {
  label: PropTypes.node,
  name: PropTypes.string.isRequired,
  register: PropTypes.func,
  errors: PropTypes.object,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  controlclass: PropTypes.string,
};
